import React, { FunctionComponent } from 'react'
import { useIntl } from 'react-intl'
import { AccessibilityInfo, ActivityIndicator } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { tID } from '../../utils/utils'

const LoadingContainer = styled.View(({ topPadding }: { topPadding: number }) => ({
  paddingTop: topPadding,
}))

/**
 * Loading indicator shown on any pages where loading content occurs
 */
export const LoadingIndicator: FunctionComponent<LoadingIndicatorProps> = ({
  size = 'large',
  color,
  topPadding = 250,
}) => {
  const { colors } = useTheme()
  const { formatMessage } = useIntl()

  return (
    <LoadingContainer
      testID={tID('LoadingIndicator')}
      topPadding={topPadding}
      accessibilityLabel={formatMessage({
        defaultMessage: 'Loading indicator',
        description: 'Accessibility label for the loading indicator container',
      })}
      accessibilityRole='progressbar'
    >
      {AccessibilityInfo.announceForAccessibility(
        formatMessage({
          defaultMessage: 'Loading, please wait',
          description: 'Announcement read by assistive technology while content loads',
        }),
      )}
      <ActivityIndicator
        size={size}
        color={color || colors.iconActive}
        accessibilityLabel={formatMessage({
          defaultMessage: 'Loading',
          description: 'Accessibility label for the loading spinner',
        })}
      />
    </LoadingContainer>
  )
}

type LoadingIndicatorProps = {
  size?: number | 'small' | 'large'
  color?: string
  topPadding?: number
}
